module.exports = __webpack_public_path__ + "static/jest-4712818f6108ac2d325b99af18be0aba.png";